/**
 * Assigned `CareRequestStatus.statusID` values.
 *
 * Unlike case statuses (`caseStatusIds.ts`, and `_memory/_context/06-known-issues.md` B6), these are
 * genuinely fixed: `CareRequestStatus.d.ts` states "Uses fixed/assigned IDs (0=Pending, 1=Approved,
 * -1=Rejected, -2=Cancelled)" and there is no `/LookUp` page that can rename or renumber them. So
 * referencing them by ID here is safe, and preferable to matching on name.
 */
export const REQUEST_STATUS = {
  Pending: 0,
  Approved: 1,
  Rejected: -1,
  Cancelled: -2,
} as const;

/**
 * Statuses the workflow owns, which `changeStatus` refuses.
 *
 * ⚠️ `CareRequestService.changeStatus` returns **400** for these. Its own JSDoc says so: reaching
 * Approved or Rejected has side effects (creating the care case and its members, notifying the
 * requester) that a bare status write would skip, leaving a request marked approved with no case behind
 * it. Use `approve()` / `reject()` instead.
 */
export const WORKFLOW_OWNED_STATUS: number[] = [REQUEST_STATUS.Approved, REQUEST_STATUS.Rejected];

/** True when this status can only be reached through `approve()` / `reject()`. */
export const isWorkflowOwned = (statusID: number) => WORKFLOW_OWNED_STATUS.includes(statusID);
